import React, { Component } from 'react';
import { IconButton, withStyles } from '@material-ui/core';
import { actionsStyles } from '../PaginationActionStyles';

export default withStyles(actionsStyles, { withTheme: true })(class TablePaginationActions extends Component {
  handleBackButtonClick = event => this.props.onChangePage(event, this.props.page - 1);

  handleNextButtonClick = event => this.props.onChangePage(event, this.props.page + 1);

  render() {
      const {
          classes, count, page, rowsPerPage, theme: { direction },
      } = this.props;
      return (
          <div className={classes.root}>
              <IconButton
                  onClick={this.handleBackButtonClick}
                  disabled={page === 0}
                  aria-label="Previous Page"
              >
                  {direction === 'rtl'
                      ? <span className="lnr lnr-chevron-right" />
                      : <span className="lnr lnr-chevron-left" />}
              </IconButton>
              <IconButton
                  onClick={this.handleNextButtonClick}
                  disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                  aria-label="Next Page"
              >
                  {direction === 'rtl'
                      ? <span className="lnr lnr-chevron-left" />
                      : <span className="lnr lnr-chevron-right" />}
              </IconButton>
          </div>
      );
  }
});



// WEBPACK FOOTER //
// ./src/components/pagination/TablePaginationActions.js